import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

import AuthStore from './auth.store.js'
import UserStore from './user.store.js'
import BotStore from './bot.store.js'
import ConversationStore from './conversation.store.js'
import EntityStore from './entities.store.js'
import IntentStore from './intent.store.js'
import LanguageStore from './language.store.js'
import ExpressionStore from './expression.store.js'
import SupportStore from './support.store.js'
import ContactStore from './contact.store.js'
import Newsletter from './newsletter.store.js'
import DashbordStore from './dashbord.store.js'
export default new Vuex.Store({
  modules: {
    Newsletter,
    SupportStore,
    DashbordStore,
    ContactStore,
    AuthStore,
    UserStore,
    BotStore,
    ConversationStore,
    EntityStore,
    IntentStore,
    LanguageStore,
    ExpressionStore
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js